import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import CronTransactionTable from '../../../components/tables/CronTransactionTable';

const CronTransaction = () => {
  // Sample data generator for Hold Transactions
  const generateSampleData = () => {
    const superDistNames = [
      'Ravi Enterprises', 'Sharma Distributors', 'Kumar Trading Co.', 
      'Singh & Sons', 'Patel Distribution', 'Verma Business Hub',
      'Gupta Services', 'Agarwal Traders', 'Reddy Corporation'
    ];
    
    const shopNames = [
      'Mobile Zone', 'Quick Recharge', 'Fast Pay Store', 'Digital Hub',
      'Telecom Center', 'Recharge Point', 'Mobile Mall', 'Tech Shop',
      'Pay & Go', 'Express Services', 'Smart Retail', 'Connect Store'
    ];
    
    const statuses = ['Success', 'Failed', 'Pending', 'Processing'];
    const types = ['Credit', 'Debit'];

    return Array.from({ length: 50 }, (_, i) => {
      const transactionDate = new Date(
        2024,
        Math.floor(Math.random() * 12),
        Math.floor(Math.random() * 28) + 1
      );
      
      const hours = String(Math.floor(Math.random() * 24)).padStart(2, '0');
      const minutes = String(Math.floor(Math.random() * 60)).padStart(2, '0');
      const seconds = String(Math.floor(Math.random() * 60)).padStart(2, '0');

      return {
        id: `CRON${String(i + 1).padStart(6, '0')}`,
        superDistName: superDistNames[Math.floor(Math.random() * superDistNames.length)],
        rMobile: `+91${Math.floor(7000000000 + Math.random() * 3000000000)}`,
        shopName: shopNames[Math.floor(Math.random() * shopNames.length)],
        systemTid: `SYS${String(Math.floor(Math.random() * 999999)).padStart(6, '0')}`,
        status: statuses[Math.floor(Math.random() * statuses.length)],
        amount: [500, 1000, 2000, 5000, 10000, 15000, 20000, 25000][
          Math.floor(Math.random() * 8)
        ],
        type: types[Math.floor(Math.random() * types.length)],
        date: transactionDate.toISOString().split('T')[0],
        time: `${hours}:${minutes}:${seconds}`,
        request: {
          api: '/api/v1/transaction',
          method: 'POST',
          payload: {
            amount: Math.floor(Math.random() * 10000),
            mobile: `+91${Math.floor(7000000000 + Math.random() * 3000000000)}`
          }
        }
      };
    });
  };

  const [cronTransactionsData] = useState(generateSampleData());

  return (
    <Container fluid className="">
      <CronTransactionTable
        data={cronTransactionsData}
        title="Hold Transactions"
      />
    </Container>
  );
};

export default CronTransaction;

